import React from 'react';
import LazyQRCode from '../LazyQRCode/LazyQRCode';
import LogoNew from '../../assets/logo-new.svg';

interface Card {
  _id: string;
  productId: string;
  serialNumber: string;
  pinNumber: string;
  cardPrice: number;
  expireDate?: string;
  scratch?: boolean;
}

interface OrderItem {
  name: string;
  productId: string;
  quantity: number;
  price: number;
  discountPrice?: number;
  discountAmount?: number;
  discountType?: string;
  discountValue?: number;
  image: string;
  code: string;
  subtotal: number;
  type: string;
  currency?:
    | {
        _id: string;
        code: string;
        name: string;
        symbol: string;
        _nameMultilingual: {
          en: string;
          my: string;
        };
      }
    | string
    | null;
  instruction?: string;
  redeemUrl?: string;
}

interface PrintAllReceiptProps {
  orderNumber: string;
  items: OrderItem[];
  cards: Card[];
  createdAt: string;
  getProductTypeByProductId: (productId: string) => string;
}

const PrintAllReceipt: React.FC<PrintAllReceiptProps> = ({
  orderNumber,
  items,
  cards,
  createdAt,
  getProductTypeByProductId,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'MMK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .format(amount)
      .replace('MMK', 'MMK ');
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Calculate total amount for all cards
  const totalAmount = cards.reduce((total, card) => total + card.cardPrice, 0);

  return (
    <div className="print-container">
      {/* <style>
        {`
           @media screen {
             .print-container { 
               display: block !important; 
               visibility: visible !important;
               position: relative !important;
             }
           }
           @media print {
             .print-container { 
               display: block !important; 
               visibility: visible !important;
               position: relative !important;
               width: 80mm;
               max-width: 80mm;
               background: white;
               font-family: 'Courier New', monospace;
               font-size: 14px;
               line-height: 1.2;
               color: black;
               padding: 8px;
               box-sizing: border-box;
               margin: 0 auto;
             }
           }
          .print-header {
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 6px;
            margin-bottom: 8px;
          }
          .print-logo {
            text-align: center;
            margin-bottom: 8px;
          }
          .print-logo img {
            width: 40mm;
            max-width: 45mm;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          .print-title {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 8px;
          }
          .print-subtitle {
            font-size: 16px;
            margin-bottom: 8px;
          }
          .print-section {
            margin-bottom: 8px;
          }
          .print-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;
            word-wrap: break-word;
            font-size: 16px;
            width: 100%;
          }
          .print-row span:first-child {
            flex: 1;
            text-align: left;
          }
          .print-row span:last-child {
            flex: 0 0 auto;
            text-align: right;
          }
          .print-divider {
            border-top: 1px solid black;
            margin: 8px 0;
          }
          .print-card {
            border: 1px solid black;
            padding: 6px;
            margin-bottom: 8px;
            page-break-inside: avoid;
            -webkit-page-break-inside: avoid;
            break-inside: avoid;
          }
          .print-card-header {
            font-weight: bold;
            text-align: center;
            margin-bottom: 4px;
            border-bottom: 1px solid black;
            padding-bottom: 4px;
            font-size: 18px;
          }
          .print-pin {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            background: #f0f0f0;
            padding: 4px;
            margin: 8px 0 4px 0;
            border: 1px solid black;
            word-break: break-all;
            letter-spacing: 1px;
          }
          .print-total {
            border-top: 2px solid black;
            border-bottom: 2px solid black;
            padding: 6px 0;
            font-weight: bold;
            text-align: center;
            margin: 8px 0;
            font-size: 18px;
          }
          .print-footer {
            text-align: center;
            margin-top: 8px;
            border-top: 1px solid black;
            padding-top: 6px;
            font-size: 12px;
            line-height: 1.3;
          }
          .print-footer div {
            margin-bottom: 2px;
          }
          .item-section {
            margin-bottom: 16px;
          }
        `}
      </style> */}
      <style>
        {`
           @media screen {
             .print-container { 
               display: block !important; 
               visibility: visible !important;
               position: relative !important;
             }
           }
           @media print {
             .print-container { 
               display: block !important; 
               visibility: visible !important;
               position: static !important;
             }
           }

           .print-container {
             position: relative;
             width: 100%;
             max-width: 80mm;
             background: white;
             font-family: 'Courier New', monospace;
             font-size: 18px;
             line-height: 1.2;
             color: black;
             padding: 8px;
             box-sizing: border-box;
             margin: 20px auto;
           }

           @page {
             size: A4;
             margin: 0mm;
           }
           
           /* Alternative page sizes for different devices */
           @media print {
             @page {
               size: auto;
               margin: 0mm;
             }
           }

          .print-header {
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 6px;
            margin-bottom: 8px;
          }
          .print-logo {
            text-align: center;
            margin-bottom: 8px;
          }
          .print-logo img {
            width: 40mm;
            max-width: 45mm;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          .print-title {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 8px;
          }
          .print-subtitle {
            font-size: 16px;
            margin-bottom: 8px;
          }
          .print-section {
            margin-bottom: 8px;
          }
          .print-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;
            word-wrap: break-word;
            font-size: 16px;
            width: 100%;
          }
          .print-row span:first-child {
            flex: 1;
            text-align: left;
          }
          .print-row span:last-child {
            flex: 0 0 auto;
            text-align: right;
          }
          .print-divider {
            border-top: 1px solid black;
            margin: 8px 0;
          }
          .print-card {
            border: 1px solid black;
            padding: 6px;
            margin-bottom: 8px;
            page-break-inside: avoid;
            /* Removed page-break-after to prevent extra blank pages */
            /* page-break-after: always; */
            -webkit-page-break-inside: avoid;
            break-inside: avoid;
          }
          .print-card-header {
            font-weight: bold;
            text-align: center;
            margin-bottom: 4px;
            border-bottom: 1px solid black;
            padding-bottom: 4px;
            font-size: 18px;
          }
          .print-pin {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            background: #f0f0f0;
            padding: 4px;
            margin: 8px 0 4px 0;
            border: 1px solid black;
            word-break: break-all;
            letter-spacing: 1px;
          }
          .print-total {
            border-top: 2px solid black;
            border-bottom: 2px solid black;
            padding: 6px 0;
            font-weight: bold;
            text-align: center;
            margin: 8px 0;
            font-size: 18px;
          }
          .print-footer {
            text-align: center;
            margin-top: 8px;
            border-top: 1px solid black;
            padding-top: 6px;
            font-size: 12px;
            line-height: 1.3;
          }
          .print-footer div {
            margin-bottom: 2px;
          }
        `}
      </style>

      {/* Single Header for all items */}
      <div className="print-header">
        <div className="print-logo">
          <img src={LogoNew} alt="logo" />
        </div>
        <div className="print-title">Purchase Receipt</div>
        <div className="print-subtitle">Order #{orderNumber}</div>
      </div>

      <div className="print-section">
        <div className="print-row">
          <span>Date:</span>
          <span>{formatDate(createdAt)}</span>
        </div>
        <div className="print-row">
          <span>Total Cards:</span>
          <span>{cards.length}</span>
        </div>
        <div className="print-row">
          <span>Total Amount:</span>
          <span>{formatCurrency(totalAmount)}</span>
        </div>
      </div>

      <div className="print-divider"></div>

      {/* Render all items */}
      {items.map((item) => {
        const itemCards = cards.filter((card) => card.productId === item.productId);

        if (itemCards.length === 0) return null;

        return (
          <div key={item.productId} className="item-section">
            <div className="print-section">
              {itemCards.map((card) => (
                <div key={card._id} className="print-card">
                  <div className="print-card-header">{item.name}</div>
                  {card.pinNumber && (
                    <div>
                      <div
                        style={{
                          marginBottom: '16px',
                          textAlign: 'center',
                          borderBottom: '1px dashed #000',
                          paddingBlock: '12px',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '12px',
                          }}
                        >
                          <div style={{ flex: 1, textAlign: 'left' }}>
                            {card.expireDate && (
                              <div style={{ fontSize: '14px', marginBottom: '4px', color: '#666' }}>
                                <span>Expire:</span>
                                <span>
                                  {' '}
                                  {new Date(card.expireDate).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                  })}
                                </span>
                              </div>
                            )}
                            <div style={{ fontSize: '14px', color: '#666' }}>
                              <span>SN:</span>
                              <span> {card.serialNumber}</span>
                            </div>
                            <div style={{ fontSize: '14px', color: '#666' }}>
                              <span>Web:</span>
                              <span> myEZTopup.com</span>
                            </div>
                          </div>
                          <div style={{ flex: 0 }}>
                            <LazyQRCode
                              value={
                                getProductTypeByProductId(card.productId) === 'prepaid'
                                  ? `tel:*123*${card.pinNumber}#`
                                  : card.pinNumber
                              }
                              size={70}
                              level="M"
                              includeMargin={false}
                              bgColor="#FFFFFF"
                              fgColor="#000000"
                              lazy={false}
                              priority="high"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="print-pin">{card.pinNumber}</div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {/* Single Total */}
      <div className="print-total">Total: {formatCurrency(totalAmount)}</div>

      {/* Single Footer for all items */}
      <div className="print-footer">
        <div>Thank you for your purchase!</div>
        <div>For support, contact us at myeztopup.com</div>
      </div>
    </div>
  );
};

export default PrintAllReceipt;
